import React from 'react';

import { Text } from '@fly/core';
import { ChatStreamingStep } from '@fly/shared';

import styles from '../../FlyChat.module.less';

interface FlyChatStreamingStepsProps {
  steps: ChatStreamingStep[];
}

const StepLabel: React.FC<{ step: ChatStreamingStep }> = ({ step }) => {
  if (step.href) {
    return (
      <a
        href={step.href}
        target='_blank'
        rel='noopener noreferrer'
        className={styles.streamingStepLink}
        data-testid='chat-streaming-step-link'
      >
        {step.label}
      </a>
    );
  }

  return (
    <Text as='span' size='1' className={styles.streamingStepLabel}>
      {step.label}
    </Text>
  );
};

export const FlyChatStreamingSteps: React.FC<FlyChatStreamingStepsProps> = ({
  steps,
}) => {
  if (!steps.length) {
    return null;
  }

  return (
    <ul className={styles.streamingSteps} data-testid='chat-streaming-steps'>
      {steps.map((step) => (
        <li
          key={step.id}
          className={`${styles.streamingStep} pb-1 !opacity-55 ${
            step.status === 'done' ? styles.streamingStepDone : ''
          } ${step.status === 'active' ? styles.streamingStepActive : ''}`}
          data-testid={`chat-streaming-step-${step.status}`}
        >
          <span className={styles.streamingStepIndicator} aria-hidden='true' />
          <StepLabel step={step} />
        </li>
      ))}
    </ul>
  );
};
